<script>
import fab_icons from '@/assets/data/fab-list.json'

export default {
  computed: {
    fab() {
      return fab_icons.includes(this.name)
    },
    icon() {
      if(this.fab) return `fab fa-${this.name}`
      return `fa-${this.name}`
    }
  },
  name: 'candela-icon',
  props: {
    name: {type: String, default: () => ''},
    icon_props: {Object, default: () => ({})}
  }
}
</script>

<template>
<v-icon v-if='icon' v-bind='icon_props' class='text--lighten-5'>
  {{icon}}
</v-icon>
</template>
